module.exports = __webpack_public_path__ + "static/media/wallet-money.c738fd83.svg";